export default __webpack_public_path__ + "static/media/gallery_00.ad1d1723.jpg";